'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { RouterOutputs } from '~/utils/api';

type AuthorizedUser = RouterOutputs['user']['authorize'] | undefined;

const ViewerBootstrapContext = createContext<AuthorizedUser>(undefined);

export function ViewerBootstrapProvider({
  authorized,
  children,
}: {
  authorized: AuthorizedUser;
  children: ReactNode;
}) {
  return (
    <ViewerBootstrapContext.Provider value={authorized}>{children}</ViewerBootstrapContext.Provider>
  );
}

export function useViewerBootstrap() {
  return useContext(ViewerBootstrapContext);
}
